module.exports = __webpack_public_path__ + "img/icologonobackgroundwhite.fca26a0c.png";